import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  FLAG_GETTING_LIQUIDATION_DIFFERENCE_REASONS,
  GET_LIQUIDATION_DIFFERENCE_REASONS,
  CLEAR_LIQUIDATION_DIFFERENCE_REASONS,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_LIQUIDATION_DIFFERENCE_REASONS:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_LIQUIDATION_DIFFERENCE_REASONS:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_LIQUIDATION_DIFFERENCE_REASONS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    default:
      return state;
  }
};
